//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import PartnerFooter from '@/components/common/footer/PartnerFooter'
import Preloader from '@/components/common/Preloader'
import GdprCookieModal from '@/modules/gdpr/components/GdprCookieModal'
import EkbModal from '@/modules/ekbModal/components/EkbModal'
import Modals from '~/components/common/section/Modals'
import CityBillet from '~/components/modals/CityBillet'

export default {
  name: 'Faculty',
  components: {
    EkbModal,
    PartnerFooter,
    GdprCookieModal,
    Modals,
    CityBillet,
    Preloader,
  },
  computed: mapGetters({
    mainSettings: 'landings/mainSettings',
    gdprSaved: 'gdpr/gdprSaved',
  }),
}
